import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const createBag = createAction(ACTION.CREATE_BAG.REQUEST, data => data);
export const clearState = createAction(ACTION.CLEAR_STATE);
export const resetError = createAction(ACTION.RESET_ERROR, (params) => ({params}));

export const fetchTemplateBags = createAction(ACTION.GET_TEMPLATE_BAGS.REQUEST, (params) => ({...params}));
